<template>
    <div class="select-select-teaching">
        <a-form-item :label="teachingLabel || $t('web.teaching_title' /* 技术职称 */)" style="margin-bottom: 0">
            <a-row :gutter="[15, 0]">
                <a-col :span="8">
                    <a-form-item>
                        <a-select
                            v-decorator="[
                                'teaching_title_reg',
                                { rules: [{ required: true, message: teachingHint || `${$t('formConfig.please_select' /* 请选择 */)}${$t('web.teaching_title' /* 技术职称 */)}` }] }
                            ]"
                            @change="value => handleChangeEvent(value, 'teaching_title_reg')"
                        >
                            <a-select-option v-for="(item, index) in teachingList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item>
                        <a-select
                            v-decorator="[
                                'teaching_title_reg_new1',
                                { rules: [{ required: true, message: teachingHint || `${$t('formConfig.please_select' /* 请选择 */)}${$t('web.teaching_title' /* 技术职称 */)}` }] }
                            ]"
                            @change="value => handleChangeEvent(value, 'teaching_title_reg_new1')"
                        >
                            <a-select-option v-for="(item, index) in subList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item v-if="$parent.form.getFieldValue('teaching_title_reg_new1') == '其他'">
                        <a-input
                            v-decorator="[
                                'teaching_title_reg_qita',
                                { rules: [{ required: true, message: teachingHint || `${$t('formConfig.please_select' /* 请选择 */)}${$t('web.teaching_title' /* 技术职称 */)}` }] }
                            ]"
                            @change="value => handleChangeEvent(value, 'teaching_title_reg_qita')"
                        ></a-input>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form-item>
    </div>
</template>

<script>
import pick from 'lodash.pick';
export default {
    name: 'SelectTeaching',
    props: {
        dataValue: {
            type: Object,
            default: () => {
                return {
                    teaching_title_reg: null,
                    teaching_title_reg_new1: null,
                    teaching_title_reg_qita: null
                };
            }
        },
        options: {
            type: Array,
            default: () => {}
        },
        teachingLabel: {
            type: String,
            default: ''
        },
        teachingHint: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            subList: [],
            teachingList: []
        };
    },
    watch: {
        dataValue: {
            handler(newVal) {
                this.showDataFun();
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 数据回显操作
        showDataFun() {
            // 数据回显
            this.$nextTick(() => {
                this.teachingList = this.options;
                console.log(this.dataValue);
                // 设置字段
                let fileds = ['teaching_title_reg', 'teaching_title_reg_new1', 'teaching_title_reg_qita'];
                if (this.dataValue.teaching_title_reg) {
                    this.handleChangeEvent(this.dataValue.teaching_title_reg, 'teaching_title_reg');
                }
                fileds.forEach(v => {
                    v && this.$parent.form.getFieldDecorator(v);
                });
                this.$parent.form.setFieldsValue(pick(this.dataValue, fileds));
            });
        },
        handleChangeEvent(value, type) {
            this.teachingList.forEach((item, index) => {
                if (item.id == value) {
                    if (type == 'teaching_title_reg') {
                        this.subList = this.teachingList.filter(item => item.id == value)[0]?.list;
                        this.$parent.form.setFieldsValue({ teaching_title_reg_new1: '' });
                    } else if (type == 'teaching_title_reg_new1') {
                        // 二级
                        this.$parent.form.setFieldsValue({ teaching_title_reg_qita: '' });
                    }
                }
            });
        }
    },
    created() {},
    mounted() {},
    destroyed() {}
};
</script>
<style scoped lang="less">
.select-teaching {
    .index-enter-item {
        /deep/.ant-row {
            margin-bottom: 0 !important;
        }
    }
    /deep/.ant-input,
    /deep/.ant-select-selection--single {
        height: 36px;
    }
    // /deep/.ant-form-item-label {
    // height: 42px;
    // line-height: 100%;
    // display: flex;
    // justify-content: flex-end;
    // align-items: center;
    // }
}
</style>
